import styled from 'styled-components';

export const FloatButtonContainer = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  padding: 0 2rem 40px;
  background-color: var(--color-background);
  max-width: var(--max-width);
  margin: 0 auto;
  width: 100%;
  z-index: 999;
`;
